import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { ALL_RISKS_COLUMN_DEFS } from '../all-risks-table.constants';

export const useRiskExportColumnNames = () => {
  const { t: tRisks } = useTranslation('riskManagement', {
    keyPrefix: 'risks',
  });

  const EXPORT_RISK_COLUMN_NAMES = useMemo(() => {
    return {
      id: tRisks(`tableHeaders.${ALL_RISKS_COLUMN_DEFS.ID}`),
      name: tRisks(`tableHeaders.${ALL_RISKS_COLUMN_DEFS.NAME}`),
      assetName: tRisks(`tableHeaders.${ALL_RISKS_COLUMN_DEFS.ASSET_NAME}`),
      'device.category': tRisks(
        `tableHeaders.${ALL_RISKS_COLUMN_DEFS.ASSET_CATEGORY}`,
      ),
      'device.os.family': tRisks(
        `tableHeaders.${ALL_RISKS_COLUMN_DEFS.ASSET_OS_NAME}`,
      ),
      state: tRisks(`tableHeaders.${ALL_RISKS_COLUMN_DEFS.STATE}`),
      status: tRisks(`tableHeaders.${ALL_RISKS_COLUMN_DEFS.STATUS}`),
      assetImportance: tRisks(
        `tableHeaders.${ALL_RISKS_COLUMN_DEFS.ASSET_CRITICALITY}`,
      ),
      source: tRisks(`tableHeaders.${ALL_RISKS_COLUMN_DEFS.SOURCE}`),
      score: tRisks(`tableHeaders.${ALL_RISKS_COLUMN_DEFS.SCORE}`),
      firstDetectedTime: tRisks(
        `tableHeaders.${ALL_RISKS_COLUMN_DEFS.FIRST_DETECTED_TIME}`,
      ),
      lastDetectedTime: tRisks(
        `tableHeaders.${ALL_RISKS_COLUMN_DEFS.LAST_DETECTED_TIME}`,
      ),
      severity: tRisks(`tableHeaders.${ALL_RISKS_COLUMN_DEFS.SEVERITY}`),
      'cve.primary.cvss.v3.score': tRisks(
        `tableHeaders.${ALL_RISKS_COLUMN_DEFS.CVSSV3}`,
      ),
      'resolution.timestamp': tRisks(
        `tableHeaders.${ALL_RISKS_COLUMN_DEFS.RESOLUTION_TIME}`,
      ),
      resolutionType: tRisks(
        `tableHeaders.${ALL_RISKS_COLUMN_DEFS.RESOLUTION_TYPE}`,
      ),
      'management.deadline': tRisks(
        `tableHeaders.${ALL_RISKS_COLUMN_DEFS.DEADLINE}`,
      ),
      'management.assignee': tRisks(
        `tableHeaders.${ALL_RISKS_COLUMN_DEFS.ASSIGNEE}`,
      ),
      'cve.primary.id': tRisks(`tableHeaders.${ALL_RISKS_COLUMN_DEFS.CVE}`),
      cisaKnownExploit: tRisks(
        `tableHeaders.${ALL_RISKS_COLUMN_DEFS.CISA_KEV}`,
      ),
      assetID: tRisks(`tableHeaders.${ALL_RISKS_COLUMN_DEFS.ASSET_ID}`),
      issueID: tRisks(`tableHeaders.${ALL_RISKS_COLUMN_DEFS.ISSUE_ID}`),
      description: tRisks('tableHeaders.description'),
      recommendations: tRisks('tableHeaders.recommendations'),
      issuePublishTime: tRisks('tableHeaders.issuePublishTime'),
      issueUpdateTime: tRisks('tableHeaders.issueUpdateTime'),
      age: tRisks('tableHeaders.age'),
      daysToResolution: tRisks('tableHeaders.daysToResolution'),
      references: tRisks('tableHeaders.references'),
      riskEvidence: tRisks('tableHeaders.riskEvidence'),
    };
  }, [tRisks]);

  return { EXPORT_RISK_COLUMN_NAMES };
};
